import { setActiveBuyBonus } from "../../../store/slices/buy-bonus";
import { useDispatch } from "react-redux";
import { useBuyBonusConfig } from "../../../hooks";
import Commander from "../../../commander";
import classes from "../../../styles/Modal.module.css";
import { getClasses } from "../../../utils";
import Modal from "../Modal";
import BonusCard from "./BonusCard";
import { useTexts } from "../../../hooks";

const SelectStakeBonus: React.FC<{ shown?: boolean }> = ({ shown }) => {
  const dispatch = useDispatch();
  const { bonuses } = useBuyBonusConfig();
  const { common } = useTexts();

  const onSelect = (bonus: string) => {
    dispatch(setActiveBuyBonus(bonus));
    Commander.openModal("buyBonus", 350);
  };

  if (!bonuses || Object.keys(bonuses).length <= 1) return null;

  return (
    <Modal
      icon="Info"
      title={common.buybonusselect}
      className={getClasses(
        classes,
        "buy-bonus",
        "buy-bonus-select",
        "fixed",
        "transparent",
        "no-text-select",
        "color text-white"
      )}
      shown={shown}
    >
      <div className={classes["bonus-cards"]}>
        {Object.keys(bonuses).map((k, i) => (
          <BonusCard
            key={i}
            bonusId={k}
            name={bonuses[k].name}
            description={bonuses[k].description}
            image={bonuses[k].images.banner}
            onClick={onSelect}
          />
        ))}
      </div>
    </Modal>
  );
};

export default SelectStakeBonus;
